<style scoped>
    @import url("../../styles/faleConosco/faleConosco.scss");
</style>

<template>
    
    <div class="box_faleConosco" v-if="!$store.state.flagMenuSup">

        <div class="painel_q mb-4">

            <div class="line_btnToBack mt-4" @click="backToMain()"
            @mouseover="hoverBackInit = 'rgb(31,122,177)'"
            @mouseleave="hoverBackInit = '#f39c12'"
            >
                <v-icon large class="mr-2" :style="{'color':hoverBackInit}">mdi-arrow-left-thick</v-icon>
                <span>Voltar</span>
            </div>

            <div class="line_tit">
                <v-icon large class="mr-2" :style="{'color':'#4B94C0'}">mdi-bell-ring</v-icon>
                <span>Fale conosco</span>
            </div>

            <div class="painelMainContent mt-8">

                <div class="body1">

                    <div class="col_esq_body1 mt-2">
                        <div class="el">
                            <span class="sub_el">E-mail: geral@upinc.pt</span>
                        </div>

                        <div class="body2">

                            <div @click="callInstagram()"
                            @mouseover="hoverInstagramOficial = '#f39c12'"
                            @mouseleave="hoverInstagramOficial = 'rgb(31,122,177)'"
                            >
                                <v-icon large class="mr-2" :style="{'color':hoverInstagramOficial}">mdi-instagram</v-icon>
                                <span>UPinC.Oficial</span>
                            </div>

                            <div @click="callLinkedin()"
                            @mouseover="hoverLinkedin = '#f39c12'"
                            @mouseleave="hoverLinkedin = 'rgb(31,122,177)'"
                            class="mt-4"
                            >
                                <v-icon large class="mr-2" :style="{'color':hoverLinkedin}">mdi-linkedin</v-icon>
                                <span>UPinC Tecnologia IoT</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col_dir_body1 hidden-sm-and-down">
                    <ContactoUp class="" />
                </div>
            
            </div> 

        </div>        
    </div>

</template>

<script>
import ContactoUp from './ContactoUp'

export default {

    components:{ContactoUp},
    
    data() {
        return {
            //
            hoverBackInit:'#f39c12', // -- init laranja
            hoverInstagramOficial:'rgb(31,122,177)',
            hoverLinkedin:'rgb(31,122,177)',
        }
    },

    methods: {
        //
        backToMain() { this.$router.push('/'); },
        callInstagram() { window.open('https://www.instagram.com/upinc.oficial/'); },
        callLinkedin() { window.open("https://www.linkedin.com/company/upinc-iot/?viewAsMember=true"); }
        
    },

    created() {
        this.$store.commit('init') // despertar api.
        window.scrollTo(0,0)
    }
}

</script>